@use 'src/globals/main';

pn-tab {
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  scroll-snap-align: center;
  display: inline-block;
  border-radius: 0.5em;
}

pn-tab .pn-tab {
  position: relative;
  cursor: pointer;

  margin: 1em 0.25em;
  padding: 0 0.25em;

  border: none;
  border-radius: 0.5em;

  color: main.$gray900;
  background-color: transparent;

  font-family: inherit;
  font-size: 1em;
  font-weight: 500;
  text-decoration: none;

  display: flex;
  gap: 0.5em;
  align-items: center;
  justify-content: center;

  -webkit-tap-highlight-color: transparent;

  @include main.pn-ripple(main.$blue700);
  @include main.pn-transition('color, outline-color, background-color');
  @include main.pn-focus-base;

  > span {
    line-height: 1.5em;
  }

  > pn-icon > .pn-icon-svg {
    path,
    polygon {
      fill: main.$gray900;
    }
  }

  &:focus-visible {
    overflow: hidden;
    @include main.pn-focus-visible(main.$blue700, main.$white);
  }

  &[aria-selected='true'],
  &[aria-current='page'] {
    color: main.$blue700;

    > pn-icon > .pn-icon-svg {
      path,
      polygon {
        fill: main.$blue700;
      }
    }
    &:focus {
      color: main.$blue900;
      pn-icon > .pn-icon-svg {
        path,
        polygon {
          fill: main.$blue900;
        }
      }
    }
  }
}
